'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = exports.updateContainerSliders = undefined;

var _pubsubJs = require('pubsub-js');

var _pubsubJs2 = _interopRequireDefault(_pubsubJs);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateParentOptionValue = function updateParentOptionValue(parent, filterGroup, filterValue) {
  if (!parent || !filterGroup || !filterValue) return false;
  var parentState = _state2.default.get(parent);
  var option = parentState._data.options.find(function (option) {
    return option.name === filterGroup;
  });

  if (option && option.values.includes(filterValue) && parentState[filterGroup] !== filterValue) {
    var topic = bva.updateOptionGroupValue + '.' + filterGroup.toUpperCase();
    var data = { id: parentState.id, name: filterGroup, value: filterValue };

    _pubsubJs2.default.publish(topic, data);
  }
};

// clean-slate
//
// const updateParentOptionValue = (parent, filterGroup, filterValue) => {
//   if (!parent || !filterGroup || !filterValue) return false;

//   const parentState = State.get(parent);
//   const option = parentState._data.options.find(option => option.name === filterGroup);

//   if (option && option.values.includes(filterValue) && parentState[filterGroup] !== filterValue) {
//     const topic = `${prg.updateOptionValue}.${filterGroup.toUpperCase()}`;
//     const data = { id: parentState.id, name: filterGroup, value: filterValue };

//     PubSub.publish(topic, data);
//   }
// };

// import { getContainer } from 'common/Helpers';

var updateContainerSliders = exports.updateContainerSliders = function updateContainerSliders(container, index) {
  var id = container.dataset.containerId;
  var name = 'slide-index';
  var value = index;

  var topic = _Constants2.default.updateContainerSliders;
  var data = { id: id, name: name, value: value };

  _pubsubJs2.default.publish(topic, data);
};

var handleSliderThumbClick = function handleSliderThumbClick(_ref) {
  var self = _ref.currentTarget;
  var _self$dataset = self.dataset,
      filterValue = _self$dataset.filterValue,
      slideIndex = _self$dataset.slideIndex;

  var _State$get = _state2.default.get(self),
      navFor = _State$get.navFor,
      parent = _State$get.parent,
      filterGroup = _State$get.filterGroup;

  updateContainerSliders(parent, slideIndex);
  updateParentOptionValue(parent, filterGroup, filterValue);

  return false;
};

// clean-slate
//
// const handleSliderThumbClick = ({ currentTarget: self }) => {
//   const { slideIndex: slideTo } = self.dataset;
//   const sliderContainer = getContainer({ self, type: 'slider' });
//   const { navFor } = State.get(sliderContainer);
//   const slider = State.get(navFor);
//   const topic = prg.updateSliderSlide;
//   const data = { slider, slideTo };

//   PubSub.publish(topic, data);

//   return false;
// };

var bindActions = exports.bindActions = function bindActions() {
  $(document).on('click', _Dom2.default.galleryThumb, handleSliderThumbClick);
};